import { fetchUtils, GET_MANY, GET_ONE } from "react-admin";

const initTeamsProvider = (
  apiUrl,
  httpClient = fetchUtils.fetchJson,
  defaultCrudHandler,
  convertDataRequestToHTTP
) => {
  return (type, resource, params) => {
    switch (type) {
      case GET_MANY:
        return httpClient(`${apiUrl}/teams?ids=${params.ids}`).then((response) => ({
          data: response.json.content,
          total: parseInt(response.json.totalElements, 10),
        }));
      case GET_ONE:
        if (params?.meta?.endpoint) {
          const urlWithParams = `${apiUrl}${params.meta.endpoint}${
            params.meta.queryParams
              ? `?${new URLSearchParams(params.meta.queryParams).toString()}`
              : ""
          }`;

          return httpClient(urlWithParams).then((response) => ({
            data: { id: params.meta.id, ...response.json },
          }));
        } else {
          return httpClient(`${apiUrl}/teams?ids=${params.id}`).then(
            (response) => ({
              data: response.json.content[0],
            })
          );
        }
      default:
        return defaultCrudHandler(type, resource, params);
    }
  };
};

export default initTeamsProvider;
